'use client'

import Card from '../Card'
import Image from 'next/image'
import Message from '../Message'
import React, { useEffect, useState } from 'react'
import { useSearch } from '../../hooks/useSearch'
import SearchForm from '../SearchForm'
import { Product } from '@medusajs/medusa'
import routes from 'web/src/lib/routes'
import LoadingIcon from '../../icons/LoadingIcon'
import { useCart } from 'medusa-react'
import { useStore } from 'web/src/lib/context/store-context'
import { useParams } from 'next/navigation'

const SearchResults = () => {
    const params = useParams()
    const term = params?.term?.toString()
    const searchFor = term || ''
    const { cart } = useCart()
    const { results } = useSearch(searchFor, cart?.context?.model as string)
    const { isSearchingProducts } = useStore()
    const [filteredResults, setFilteredResults] = useState<Product[]>([])

    const filterResults = (results?: Product[] | null) => {
        if (!results) {
            return []
        }

        if (!cart?.context?.model) {
            return results
        }

        return results.filter(result => {
            if (!result?.categories) {
                return true
            }

            return result?.categories?.some(categorie => {
                const categorieString = categorie as unknown as string
                return categorieString.replace(/ /g, '-').toLowerCase() === cart.context.model
            })
        })
    }

    useEffect(() => {
        setFilteredResults(filterResults(results))
    }, [results, cart?.context?.model])

    console.log('results', results)

    return (
        <div>
            <h1 className="py-8">Resultaten voor {unescape(searchFor)}</h1>
            {isSearchingProducts ? (
                <LoadingIcon />
            ) : filteredResults && filteredResults?.length > 0 ? (
                <div className={'grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-3 md:flex-row md:flex-wrap'}>
                    {filteredResults.map((product, index) => {
                        return (
                            <Card
                                key={product.id}
                                title={product.title}
                                prices={product.variants[0]?.prices}
                                to={`${routes.product}/${product.handle}`}
                                image={
                                    <Image
                                        loading={index < 8 ? 'eager' : 'lazy'}
                                        priority={index < 8}
                                        src={product.thumbnail || ''}
                                        alt={`Product: ${product.title}`}
                                        width={288}
                                        height={240}
                                        className={'w-full'}
                                    />
                                }
                            />
                        )
                    })}
                </div>
            ) : (
                <Message color={'red'}>
                    <div className="flex flex-col gap-y-2">
                        <p className="font-medium">Geen resultaten</p>
                        <p>Helaas konden we geen resulaten vinden voor uw zoekopdracht. Probeer het opnieuw.</p>
                        <SearchForm />
                    </div>
                </Message>
            )}
        </div>
    )
}

export default SearchResults
